import { httpClient } from "@/app/old/desktop/shared/services/";
import { BaseService } from "@/app/old/desktop/shared/services/";
const URL = "categories";

class API extends BaseService {
  constructor() {
    super(null, URL);
  }
}

export const categoryService = new API();
